<template>
	<div>
		<v-dialog v-model="numberSeriesDialog" no-click-animation persistent scrollable content-class="full-height select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width class="pr-0">Select Number Series
		        		<v-spacer></v-spacer>
		        		<!-- <v-btn color="primary" small flat justify-content-to-end nomargin :ripple="false" @click="fn_newNumberSeries">new</v-btn></v-subheader> -->
		        		<v-btn flat icon @click="fn_newNumberSeries">
	        				<v-icon class="primary-color">add</v-icon>
	        			</v-btn>
        			</v-subheader>

	        		<v-text-field  solo flat placeholder="Search" v-model="searchValue"></v-text-field>
	        	</v-card-title>
	        	<!-- <v-divider></v-divider> -->
		        <v-card-text full-height nopadding :class="{'no-items-list-card': !filteredItems.length}">

			        <v-list nopadding>
			        	<v-list-tile v-for="(item, index) in filteredItems" :key="index" @click="setNumberSeries(item)">

				            <v-list-tile-content>
				              <v-list-tile-title>{{item.name}}</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
						        <v-icon v-if="item.name == selectedNumberSeries">radio_button_checked</v-icon>
						        <v-icon v-else>radio_button_unchecked</v-icon>
				            </v-list-tile-action>
			        	</v-list-tile>
			        </v-list>

			        <div class="display_msg" v-if="!filteredItems.length">No Items</div>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		          	<!-- <v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">ok</v-btn> -->
		        </v-card-actions>
		    </v-card>


	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['setNumberSeries', 'getFormData'],
		data(){
			return{
				// numberSeriesList:[
				// 	{"numberSeriesId":1,  "name":"Tax Invoice", "prefix":"RCT",  "suffix":"HOD", "nextNumber":"12001"}, 
				// 	{"numberSeriesId":2,  "name":"Cash Memo", "prefix":"RCT",  "suffix":"HOD", "nextNumber":"12002"}, 
				// 	{"numberSeriesId":3,  "name":"Challan", "prefix":"RCT",  "suffix":"HOD", "nextNumber":"12003"}, 
				// ],
				numberSeriesList:[],
				selectedNumberSeries: null,
				numberSeriesDialog:false,
				searchValue:''
			}
		},
		methods:{
			openDialogWeb: function () {
				this.fn_getItems();
				this.searchValue = '';
				let formData = this.getFormData();
				formData.numberSeriesName ? this.selectedNumberSeries = formData.numberSeriesName : this.selectedNumberSeries = null;
				this.numberSeriesDialog = true;
			},
			closeDialogWeb: function () {
				this.numberSeriesDialog = false;
			},
			fn_newNumberSeries: function () {
				this.$router.push({path:'/numberseries/items/new', query:{tagId:this.guidWeb(), ls:1}});
			},
			fn_getItems: function () {
		        let filterObject = {};

		        let self = this;
		        this.getItems("NumberSeriesList", filterObject, 
		          {
		            onSuccess: function (response) {
		              console.log(response);
		              self.numberSeriesList = JSON.parse(response);
		            },
		            onError: function (error) {
		              console.log(error);
		            }
		          }
		        )
		    },
		},
		computed:{
			filteredItems: function () {
		        let searchText = this.searchValue.toLowerCase();

		        return this.numberSeriesList.filter(item => {
		          let seriesName = item.name.toLowerCase();
		          return seriesName.match(searchText);
		        })
		      }
		}
	}
</script>

<style>
	.select_field_dialog .v-input{
		padding-top: 0;
		margin:0;
	}
	.select_field_dialog .v-input .v-radio{
		margin-bottom:12px;
	}
	.select_field_dialog .v-input .v-radio .v-label{
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/number_series/dialog_number_series.vue